// features/notifications/NotificationTabs.tsx — type-filter tab bar (wraps the ui Tabs primitive).

import { Tabs } from '@/ui';
import { TYPE_TABS } from './meta';
import type { TypeFilter } from './filterNotifications';

export interface NotificationTabsProps {
  active: TypeFilter;
  onChange: (type: TypeFilter) => void;
}

export function NotificationTabs({ active, onChange }: NotificationTabsProps) {
  return (
    <Tabs
      items={TYPE_TABS.map((t) => ({ value: t.id, label: t.label }))}
      value={active}
      onChange={(v) => onChange(v as TypeFilter)}
    />
  );
}
